
export default function ServicesQuote() {
  return (
    <>
    <section className="service-quote">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-6 col-md-7">
                    <h2 className="heading aboutpoint-detail wow animate__animated animate__fadeInUp" data-wow-duration="1.4s" data-wow-delay="0.2s">Focused on individuality, we craft solutions where personality, elegance, and functionality perfectly converge.</h2>
                </div>
            </div>
        </div>
    </section>  
    </>
  )
}
